import styled, { css } from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';

export const BopisFilterWrapper = styled.div`
  height: 46px;
  width: auto;
  box-sizing: border-box;
  padding: 12px 16px;
  display: inline-flex;
  border-radius: 6px;
  background-color: #edf5fb;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;

  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    font-size: 16px;
    margin-bottom: 16px;
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    width: 100%;
    height: 65px;
    font-size: 13px;
    margin-bottom: 16px;
  }
`;

export const StoreInfo = styled.div`
  display: inline-flex;
  flex-direction: row;
  font-family: Nunito;

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    flex-direction: column;
  }
`;

export const StoreChangeWrapper = styled.div`
  margin-left: 10px;
  display: flex;

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    margin-left: 0px;
    text-transform: capitalize;
    font-weight: bold;
  }
`;

export const ChangeStoreLink = styled.div`
  font-size: 14px;
  display: inline-block;
  cursor: pointer;
  text-decoration: underline;
  margin-top: 2px;
  @media ${(props) => props.theme.mediaQuery.medium} {
    &.select-store {
      font-size: 14px;
      margin-top: 2px;
    }
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: 12px;
  }
`;

export const BopisStoreName = styled(BodyCopy)`
  text-transform: capitalize;
`;

export const SwitchFilter = styled.div`
  margin-right: 10px;
`;

export default css`
  .header-pickup-line {
    text-transform: capitalize;
  }
`;
